import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import AddOpenHour from "./AddOpenHour";
import PhoneNumberInput from "../../../../components/common/PhoneNumberInput";
import { validateMin } from "../../../../utils/validateMin";
import useDelete from "../../../../components/hooks/useDelete";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

type OpenHourType = {
  id: number;
  locationId: number;
  startDate: string;
  endDate: string;
  branchId: number;
  isSundayOpen: boolean;
  sundayOpenTime: string;
  sundayCloseTime: string;
  isMondayOpen: boolean;
  mondayOpenTime: string;
  mondayCloseTime: string;
  isTuesdayOpen: boolean;
  tuesdayOpenTime: string;
  tuesdayCloseTime: string;
  isWednesdayOpen: boolean;
  wednesdayOpenTime: string;
  wednesdayCloseTime: string;
  isThursdayOpen: boolean;
  thursdayOpenTime: string;
  thursdayCloseTime: string;
  isFridayOpen: boolean;
  fridayOpenTime: string;
  fridayCloseTime: string;
  isSaturdayOpen: boolean;
  saturdayOpenTime: string;
  saturdayCloseTime: string;
  uniqueId: number;
};

export const AddFleetLocation = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const navigate = useNavigate();
  const [isGeneralSettings, setIsGeneralSettings] = useState<boolean>(true);
  const [isAddress, setIsAddress] = useState<boolean>(true);
  const [isWebsite, setIsWebsite] = useState<boolean>(true);
  const [isAdditionalChargesAndFees, setIsAdditionalChargesAndFees] = useState<boolean>(true);
  const [isOpeningDetails, setIsOpeningDetails] = useState<boolean>(true);
  const [locationName, setLocationName] = useState<string>("");
  const [isAirport, setIsAirport] = useState<string>("No");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [isShowOnWebsite, setIsShowOnWebsite] = useState<string>("No");
  const [prefixForReservation, setPrefixForReservation] = useState<string>("");
  const [branchId, setBranchId] = useState<string>("");
  const [branches, setBranches] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [isActive, setIsActive] = useState<string>("No");
  const [isImages, setIsImages] = useState<string>("No");
  const [mandatoryAdditionalCharges, setMandatoryAdditionalCharges] =
    useState<string>("");
  const [
    defaultFuelPricePerLiterOrGallon,
    setDefaultFuelPricePerLiterOrGallon,
  ] = useState<string>("");
  const [tax, setTax] = useState<string>("");
  const [locationFee, setLocationFee] = useState<string>("");
  const [governmentTax, setGovernmentTax] = useState<string>("");
  const [supportedCurrencies, setSupportedCurrencies] = useState<string>("");
  const [taxLabel, setTaxLabel] = useState<string>("");
  const [locationFeeLabel, setLocationFeeLabel] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [zipCode, setZipCode] = useState<string>("");
  const [street, setStreet] = useState<string>("");
  const [latitude, setLatitude] = useState<string>("");
  const [longitude, setLongitude] = useState<string>("");
  const [websiteLink, setWebsiteLink] = useState<string>("");
  const [preventBookingsInClosedHours, setPreventBookingsInClosedHours] = useState<string>("No");
  const [allowPickupDuringClosedHours, setAllowPickupDuringClosedHours] = useState<string>("No");
  const [
    minimumHoursRequiredBeforePickup,
    setMinimumHoursRequiredBeforePickup,
  ] = useState<string>("");
  const [allowReturnDuringClosedHours, setAllowReturnDuringClosedHours] = useState<string>("No");
  const [returnInfo, setReturnInfo] = useState<string>("");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  const [addOpenHour, setAddOpenHour] = useState<OpenHourType[]>([
    {
      id: 0,
      locationId: 0,
      startDate: "",
      endDate: "",
      branchId: 0,
      isSundayOpen: false,
      sundayOpenTime: "",
      sundayCloseTime: "",
      isMondayOpen: false,
      mondayOpenTime: "",
      mondayCloseTime: "",
      isTuesdayOpen: false,
      tuesdayOpenTime: "",
      tuesdayCloseTime: "",
      isWednesdayOpen: false,
      wednesdayOpenTime: "",
      wednesdayCloseTime: "",
      isThursdayOpen: false,
      thursdayOpenTime: "",
      thursdayCloseTime: "",
      isFridayOpen: false,
      fridayOpenTime: "",
      fridayCloseTime: "",
      isSaturdayOpen: false,
      saturdayOpenTime: "",
      saturdayCloseTime: "",
      uniqueId: 1,
    },
  ]);
  const [uniqueNumber, setUniqueNumber] = useState<number>(2);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranches(() =>
          response.data.map((item: any) => {
            return { value: item.id, label: item.branchName };
          })
        );

        setBranchId(response.data[0]?.id);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    const openHourData = addOpenHour.map((item: any) => {
      return {
        startDate: item.startDate,
        endDate: item.endDate,
        branchId: branchId,
        isSundayOpen: item.isSundayOpen,
        sundayOpenTime: item.sundayOpenTime,
        sundayCloseTime: item.sundayCloseTime,
        isMondayOpen: item.isMondayOpen,
        mondayOpenTime: item.mondayOpenTime,
        mondayCloseTime: item.mondayCloseTime,
        isTuesdayOpen: item.isTuesdayOpen,
        tuesdayOpenTime: item.tuesdayOpenTime,
        tuesdayCloseTime: item.tuesdayCloseTime,
        isWednesdayOpen: item.isWednesdayOpen,
        wednesdayOpenTime: item.wednesdayOpenTime,
        wednesdayCloseTime: item.wednesdayCloseTime,
        isThursdayOpen: item.isThursdayOpen,
        thursdayOpenTime: item.thursdayOpenTime,
        thursdayCloseTime: item.thursdayCloseTime,
        isFridayOpen: item.isFridayOpen,
        fridayOpenTime: item.fridayOpenTime,
        fridayCloseTime: item.fridayCloseTime,
        isSaturdayOpen: item.isSaturdayOpen,
        saturdayOpenTime: item.saturdayOpenTime,
        saturdayCloseTime: item.saturdayCloseTime,
      };
    });

    await axios
      .post(
        `${baseURL}location?userId=${auth?.id}`,
        JSON.stringify({
          locationName,
          prefixForReservation,
          branchId,
          isAirport: isAirport === "Yes",
          websiteLink,
          emailAddress,
          phoneNumber,
          isShowOnWebsite: isShowOnWebsite === "Yes",
          isActive: isActive === "Yes",
          isImages: isImages === "Yes",
          returnInfo,
          street,
          city,
          state,
          zipCode,
          country,
          latitude,
          longitude,
          supportedCurrencies,
          locationFeeLabel,
          locationFee,
          taxLabel,
          tax,
          mandatoryAdditionalCharges,
          governmentTax,
          defaultFuelPricePerLiterOrGallon,
          preventBookingsInClosedHours: preventBookingsInClosedHours === "Yes",
          minimumHoursRequiredBeforePickup,
          allowReturnDuringClosedHours: allowReturnDuringClosedHours === "Yes",
          allowPickupDuringClosedHours: allowPickupDuringClosedHours === "Yes",
          locationOpenHours: openHourData
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  const addNewRow = () => {
    const addOpenHourData: OpenHourType = {
      id: 0,
      locationId: 0,
      startDate: "",
      endDate: "",
      branchId: 0,
      isSundayOpen: false,
      sundayOpenTime: "",
      sundayCloseTime: "",
      isMondayOpen: false,
      mondayOpenTime: "",
      mondayCloseTime: "",
      isTuesdayOpen: false,
      tuesdayOpenTime: "",
      tuesdayCloseTime: "",
      isWednesdayOpen: false,
      wednesdayOpenTime: "",
      wednesdayCloseTime: "",
      isThursdayOpen: false,
      thursdayOpenTime: "",
      thursdayCloseTime: "",
      isFridayOpen: false,
      fridayOpenTime: "",
      fridayCloseTime: "",
      isSaturdayOpen: false,
      saturdayOpenTime: "",
      saturdayCloseTime: "",
      uniqueId: uniqueNumber,
    };

    setAddOpenHour((addOpenHour: OpenHourType[]) => [
      ...addOpenHour,
      addOpenHourData,
    ]);
    setUniqueNumber(uniqueNumber + 1);
  };

  const changeDataOnOpenHour = (data: OpenHourType, index: number) => {
    setAddOpenHour((addOpenHour) =>
      addOpenHour.map((rowValue: OpenHourType, i: number) => {
        return i === index ? data : rowValue;
      })
    );
  };

  const deleteTheFleetOpenHour = (uniqueNumber: number) => {
    setDeleteData({
      id: 0,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Open Hour?`,
      isDelete: async (callback: any) => {
        const updateData: OpenHourType[] = addOpenHour.filter(
          (item: OpenHourType) => item.uniqueId !== uniqueNumber
        );
        setAddOpenHour(() => updateData);
        callback();
      }
    });

    setDeletePopup(true);
  };


  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Fleet Location</h2>
                </div>
              </div>

              <div className="mt-2 p-2 w-3/4">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsGeneralSettings(!isGeneralSettings)}
                  >
                    {isGeneralSettings ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      General Settings
                    </div>
                  </h5>
                  <hr />

                  <div className="w-full px-2">
                    {isGeneralSettings &&
                      <div className="grid grid-cols-2 gap-6 mt-1.5">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={locationName}
                              onChange={(e) => setLocationName(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={branchId}
                              onChange={(e) => setBranchId(e.target.value)}
                            >
                              {branches?.map((role: any, index: number) => (
                                <option key={index} value={role.value}>
                                  {role.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>CC Email?</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={emailAddress}
                              onChange={(e) => setEmailAddress(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Info</label>
                            <textarea
                              name="returnInfo"
                              rows={4}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={returnInfo}
                              onChange={(e) => setReturnInfo(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Prefix For Reservation #</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={prefixForReservation}
                              onChange={(e) => setPrefixForReservation(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Phone Number</label>
                            <PhoneNumberInput
                              name={"phoneNumber"}
                              value={phoneNumber}
                              setValue={setPhoneNumber}
                              fontSize={"14px"}
                              paddingBlock={"7px"}
                              required={true} />
                          </div>

                          <div className="w-full flex items-start justify-between mt-[20px]">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Is Airport?</label>
                              <RadioGroup
                                row
                                value={isAirport}
                                onChange={(e) => setIsAirport(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />

                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>

                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                              <RadioGroup
                                row
                                value={isActive}
                                onChange={(e) => setIsActive(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />

                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>
                          </div>

                          <div className="w-full flex items-start justify-between mt-[20px]">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Show On Website?</label>
                              <RadioGroup
                                row
                                value={isShowOnWebsite}
                                onChange={(e) => setIsShowOnWebsite(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>

                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images?</label>
                              <RadioGroup
                                row
                                value={isImages}
                                onChange={(e) => setIsImages(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsAddress(!isAddress)}
                    >
                      {isAddress ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Address
                      </div>
                    </h5>
                    <hr />

                    {isAddress &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Street</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={street}
                              onChange={(e) => setStreet(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>State</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={state}
                              onChange={(e) => setState(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Country</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={country}
                              onChange={(e) => setCountry(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Latitude</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={latitude}
                              onChange={(e) => setLatitude(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>City</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required
                            />

                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Zip Code</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={zipCode}
                              inputMode="numeric"
                              onChange={(e) => setZipCode(e.target.value.replace(/\D/g, ""))}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Street</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Longitude</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={longitude}
                              onChange={(e) => setLongitude(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsWebsite(!isWebsite)}
                    >
                      {isWebsite ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Website
                      </div>
                    </h5>
                    <hr />

                    {isWebsite &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={websiteLink}
                              onChange={(e) => setWebsiteLink(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsAdditionalChargesAndFees(!isAdditionalChargesAndFees)}
                    >
                      {isAdditionalChargesAndFees ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Additional Charges & Fees
                      </div>
                    </h5>
                    <hr />

                    {isAdditionalChargesAndFees &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mandatory Additonal Charges</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={mandatoryAdditionalCharges}
                              onChange={(e) =>
                                setMandatoryAdditionalCharges(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tax (%)</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={tax}
                              onChange={(e) => setTax(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Location Tax (%)</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={locationFee}
                              onChange={(e) => setLocationFee(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Government Tax (%)</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={governmentTax}
                              onChange={(e) => setGovernmentTax(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Supported Currencies</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={supportedCurrencies}
                              onChange={(e) =>
                                setSupportedCurrencies(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tax Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={taxLabel}
                              onChange={(e) =>
                                setTaxLabel(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Location Fee Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={locationFeeLabel}
                              onChange={(e) =>
                                setLocationFeeLabel(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Fuel Price Per Liter Or Gallon</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultFuelPricePerLiterOrGallon}
                              onChange={(e) =>
                                setDefaultFuelPricePerLiterOrGallon(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsOpeningDetails(!isOpeningDetails)}
                    >
                      {isOpeningDetails ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Opening Details
                      </div>
                    </h5>
                    <hr />

                    {isOpeningDetails &&
                      <>
                        <div className="grid grid-cols-2 gap-6 mt-2">
                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Prevent Bookings In Closed Hours</label>
                              <RadioGroup
                                row
                                value={preventBookingsInClosedHours}
                                onChange={(e) => setPreventBookingsInClosedHours(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>

                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allow Pickup During Closed Hours</label>
                              <RadioGroup
                                row
                                value={allowPickupDuringClosedHours}
                                onChange={(e) => setAllowPickupDuringClosedHours(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>
                          </div>

                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Hours Required Before Pickup</label>
                              <input
                                type="number"
                                min={0}
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={minimumHoursRequiredBeforePickup}
                                onChange={(e) =>
                                  setMinimumHoursRequiredBeforePickup(
                                    validateMin(e.target.value, 0).toString()
                                  )
                                }
                                required
                              />
                            </div>

                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allow Return During Closed Hours</label>
                              <RadioGroup
                                row
                                value={allowReturnDuringClosedHours}
                                onChange={(e) => setAllowReturnDuringClosedHours(e.target.value)}
                              >
                                <FormControlLabel
                                  value="Yes" control=
                                  {<Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="Yes"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                                <FormControlLabel value="No" control={
                                  <Radio
                                    sx={{
                                      color: "gray",
                                      "&.Mui-checked": {
                                        color: "blue",
                                      },
                                    }}
                                  />} label="No"
                                  sx={{
                                    color: themeStyles.form.labelTextColor
                                  }}
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                        {
                          addOpenHour?.map((item: OpenHourType, index: number) => {
                            return (
                              <AddOpenHour
                                key={index}
                                index={index}
                                uniqueNumber={item.uniqueId}
                                data={item}
                                changeDataOnOpenHour={(data: OpenHourType, index: number) =>
                                  changeDataOnOpenHour(data, index)
                                }
                                deleteTheFleetOpenHour={deleteTheFleetOpenHour}
                              />
                            )
                          })
                        }

                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg,
                            marginTop: "10px"
                          }}
                          onClick={() => addNewRow()}
                        >
                          Add New Open Hour Block
                        </Button>
                      </>
                    }

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit"
                      >
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}

